import classNames from "classnames";
import _ from "lodash";
import { useFormContext } from "react-hook-form";
import { FormFieldProps } from "./LInputField";
import { LTooltip } from "./LTooltip";

export const LCheckbox = ({ ...props }: CheckboxProps): JSX.Element => {
    const {
        register,
        formState: { errors }
    } = useFormContext();
    const error = _.get(errors, props.inputName);
    const hasError = error !== undefined && error !== null && !props.hideError;
    const fieldError = error?.message?.toString() ?? "";
    const classes = classNames("checkbox", hasError ? "is-danger" : "", props.classes);

    return (
        <div className="field">
            <label className={`${classes} is-flex`}>
                {props.rightSided && <span className="mr-2">{props.label}</span>}
                {props.tooltip?.length && (
                    <div className="mr-4">
                        <LTooltip text={props.tooltip} direction={props.tooltipDirection} />
                    </div>
                )}
                <input
                    type="checkbox"
                    checked={props.checked}
                    value={props.value}
                    {...register(props.inputName, { onChange: props.onChange })}
                    defaultChecked={props.defaultChecked}
                    className={hasError ? "border-danger" : ""}
                />
                {!props.rightSided && <span className="ml-2">{props.label}</span>}
            </label>
            {hasError && !props.hideErrorLabel && <p className="help is-danger">{fieldError}</p>}
        </div>
    );
};

interface CheckboxProps extends FormFieldProps {
    checked?: boolean;
    rightSided?: boolean;
    tooltip?: string;
    tooltipDirection?: "up" | "down";
    classes?: string;
    hideError?: boolean;
    hideErrorLabel?: boolean;
    defaultChecked?: boolean;
}
